var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignNewSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64294 14.7663L18.9561 18.204C19.1581 18.2706 19.3729 18.2883 19.5831 18.2556C19.7931 18.2229 19.9925 18.1407 20.1647 18.016C20.3382 17.8925 20.4798 17.7294 20.578 17.5402C20.676 17.3511 20.7277 17.1414 20.7287 16.9283V5.87659C20.7277 5.66355 20.676 5.45379 20.578 5.26467C20.4798 5.07554 20.3382 4.91245 20.1647 4.78888C19.9913 4.66633 19.7915 4.58662 19.5813 4.55627C19.3713 4.52593 19.157 4.54582 18.9561 4.61431L8.64294 8.05202V14.7663Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27148 11.4092C3.27148 11.8501 3.35832 12.2866 3.52703 12.6939C3.69574 13.1012 3.94303 13.4713 4.25476 13.7831C4.88435 14.4127 5.73826 14.7663 6.62863 14.7663H8.64291V8.05206H6.62863C6.18777 8.05206 5.75122 8.13889 5.3439 8.30761C4.9366 8.47633 4.56651 8.72361 4.25476 9.03534C3.62518 9.66493 3.27148 10.5188 3.27148 11.4092Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62866 14.7664V16.1093C6.62866 16.5501 6.71549 16.9867 6.88421 17.394C7.05292 17.8013 7.30021 18.1714 7.61194 18.483C7.92369 18.7948 8.29378 19.0421 8.70108 19.2109C9.1084 19.3795 9.54494 19.4664 9.9858 19.4664",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignNewSelected);
export default __webpack_public_path__ + "static/media/CampaignNewSelected.8f9fa8b5089023f0a753c26cc853ea2d.svg";
export { ForwardRef as ReactComponent };